<template>
	<div>
		<modal-confirmacao
			id="excluir"
			:exibir="exibirModalExclusaoPedido"
			:mensagem="mensagemExclusaoPedido"
			@fechar-modal="abrirOuFecharModalExclusao"
			@confirmar="excluir"
			:subtituloModal="subtituloModalExclusao"
			:tituloModal="tituloModalexclusao"
		></modal-confirmacao>
		<v-data-table
			:items="pedidos"
			:headers="colunas"
			:page="busca.paginacao.page"
			:items-per-page="busca.paginacao.rowsPerPage"
			hide-default-footer
		>
			<template #item.numeropedido="{ item }">
				<span>{{ item.numeroPedido | numeroPedidoFilter }}</span>
			</template>
			<template #item.dataCadastro="{ item }">
				<texto-tooltip
					:texto="azDate(item.dataCadastro)"
					:texto-tooltip="item.nomeUsuario"
					:tamanho-maximo="40"
				>
				</texto-tooltip>
			</template>
			<template #item.atividade="{ item }">
				<div class="d-flex flex-column align-content-stretch">
					<span>{{ item.atividadeNome }}</span>
					<span>{{ item.atividadeSituacao }}</span>
				</div>
			</template>
			<template #item.acoes="{ item }">
				<div class="d-flex flex-row justify-end">
					<botao-tooltip
						icone="mdi-login"
						v-az-auth="permissoes.pedidoUtilizacaoVisualizar"
						cor="grey"
						texto="Acessar"
						@click="acessar(item)"
					></botao-tooltip>
					<v-menu offset-y>
						<template #activator="{ on, attrs }">
							<v-btn
								v-if="!isHistoricoProrrogacao && !isAtaCancelada"
								v-az-auth="permissoes.pedidoUtilizacaoVisualizar"
								icon
								color="grey"
								v-on="on"
								v-bind="attrs"
							>
								<v-icon>mdi-dots-vertical</v-icon>
							</v-btn>
						</template>
						<v-list>
							<v-list-item
								class="list-item-height"
								data-testid="excluirPedido"
								v-az-auth="permissoes.pedidoUtilizacaoExcluir"
								@click="abrirOuFecharModalExclusao(item)"
							>
								<v-icon :size="tamanhoIconeMenu" class="material-icons mr-2">mdi-delete</v-icon>
								<v-list-item-title class="texto-menu-interno">Excluir</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</div>
			</template>
		</v-data-table>
		<paginacao-tabela
			:total-paginas="totalPages"
			:total-itens="totalElements"
			:page.sync="busca.paginacao.page"
			:rows-per-page="busca.paginacao.rowsPerPage"
			:show-rows-per-page="false"
			@resetar-page="resetarPaginaListagem"
		></paginacao-tabela>
	</div>
</template>
<script>
import { TabelaColunaUtils } from '@/core/utils'
import { actionTypes, routesNames } from '@/core/constants'
import MenuAcoes from '@/views/components/MenuAcoes.vue'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import validacaoAta from '@/views/mixins/validacaoAta'
import permissoesMixin from '@/views/mixins/permissoes-mixin'
import { mapState } from 'vuex'
import azDate from '@azinformatica/loki/src/filters/az-date'

export default {
	name: 'listagem-pedidos-por-num-processo',
	components: { TextoTooltip, ModalConfirmacao, MenuAcoes },
	mixins: [validacaoAta, permissoesMixin],
	props: {
		filtro: {
			type: Object,
			required: true,
		},
		abertos: {
			type: Array,
			required: true,
		},
		totalItensProcessos: {
			type: Number,
			required: true,
		},
	},
	emits: ['recarregar-processos'],
	data() {
		return {
			pedidos: [],
			totalElements: 0,
			totalPages: 0,
			exibirModalExclusaoPedido: false,
			mensagemExclusaoPedido: 'O Pedido excluído não poderá ser recuperado!',
			subtituloModalExclusao: 'Deseja realmente excluir?',
			tituloModalexclusao: 'Excluir',
			tamanhoIconeMenu: '18px',
			pedidoParaExcluir: {},
			colunas: [
				new TabelaColunaUtils('N° Pedido', 'numeropedido', '20%'),
				new TabelaColunaUtils('Criação', 'dataCadastro', '20%'),
				new TabelaColunaUtils('N° Ata', 'numeroAta', '20%'),
				new TabelaColunaUtils('Atividade', 'atividade', '30%'),
				new TabelaColunaUtils('', 'acoes', '10%'),
			],
			busca: this.filtro,
		}
	},
	computed: {
		...mapState({
			informacoesAta: (state) => state.ata.informacoesAta,
		}),
		isHistoricoProrrogacao() {
			return this.informacoesAta && this.ehHistoricoProrrogacao(this.informacoesAta)
		},
		isAtaCancelada() {
			return this.estaCancelada(this.informacoesAta.situacao)
		},
	},
	watch: {
		filtro: {
			handler(novoValor) {
				this.busca = novoValor
				this.carregarPedidosDoProcesso()
			},
			deep: true,
		},
	},
	async mounted() {
		await this.carregarPedidosDoProcesso()
	},
	methods: {
		azDate,
		abrirOuFecharModalExclusao(item) {
			this.pedidoParaExcluir = [item]
			this.exibirModalExclusaoPedido = !this.exibirModalExclusaoPedido
		},
		async excluir() {
			this.exibirModalExclusaoPedido = false
			await this.$store.dispatch(actionTypes.PEDIDO.EXCLUIR_PEDIDO, this.pedidoParaExcluir[0].idPedido)
			this.mostrarNotificacaoSucesso('Pedido de utilização excluido com sucesso!')
			this.resetarListagens()
			await this.$emit('recarregar-processos')
			await this.carregarPedidosDoProcesso()
		},
		acessar(pedido) {
			this.$router.push({
				name: routesNames.PEDIDO.ACESSAR_ITENS_VIEW,
				params: { id: pedido.idPedido, tipoAcesso: 'editar' },
				query: { origin: 'AtaAcessarGestaoPedidoView' },
			})
		},
		async carregarPedidosDoProcesso() {
			let { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ATA.GESTAO_PEDIDO.BUSCAR_LISTAGEM_PEDIDOS_POR_PROCESSO,
				this.busca,
			)

			this.pedidos = itens
			this.totalElements = totalElements
			this.totalPages = totalPages
		},
		resetarListagens() {
			if (this.pedidos.length === 1) this.resetarPaginaListagem()
			if (this.pedidos.length === 1 && this.totalItensProcessos === 1) this.$emit('reset-page-processos')
		},
		resetarPaginaListagem() {
			this.busca.paginacao.page = 1
		},
	},
}
</script>

<style scoped lang="stylus">
.font-size-grande
	font-size 28px !important

.texto-menu-interno
	font-size 0.8em

.list-item-height
	min-height 0 !important

.v-list-item--disabled
	cursor not-allowed !important
</style>
